import axios from "axios";
import {
  get_cares,
  cares_form,
  get_cares_faq,
  get_cares_platinum,
  get_cares_terms,
} from "../apiConfig";
import { getToken } from "../../localstorage";

// 18/09/2023, using language id
const api_cares = async (lang) => {
  try {
    const response = await axios.get(get_cares, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        lang: lang,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const api_cares_form = async (formData) => {
  try {
    const response = await axios.post(cares_form, formData, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const api_cares_faq = async (lang) => {
  try {
    const response = await axios.get(get_cares_faq, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        lang: lang,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const api_cares_platinum = async (lang) => {
  try {
    const response = await axios.get(get_cares_platinum, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        lang: lang,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const api_cares_terms = async (lang) => {
  try {
    const response = await axios.get(get_cares_terms, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        lang: lang,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export {
  api_cares,
  api_cares_form,
  api_cares_faq,
  api_cares_platinum,
  api_cares_terms,
};
